<template>
	<div :class="['avatar', className]">
		<i v-if="icon" :class="'icon-'+icon"></i>
		<span v-else>{{letter}}</span>
	</div>
</template>

<script>
	import store from 'core/store';

	const idToBookToClass = new Map();

	function getBookerOrder(booker) {
		const bookKey = booker.parentKey;
		const bookId = bookKey.id;
		let bookerIdToClass = idToBookToClass.get(bookId);
		if (!bookerIdToClass) {
			const bookers = store.getByParent(bookKey, 'Booker').sort((a, b) => {
				let result = b.ctime - a.ctime;
				if (result === 0) {
					result = b.id - a.id;
				}
				return result;
			});
			bookerIdToClass = new Map();
			let i = 1;
			for (let booker of bookers) {
				bookerIdToClass.set(booker.id, i);
				i += 1;
			}
			idToBookToClass.set(bookId, bookerIdToClass);
		}
		return bookerIdToClass.get(booker.id);
	}

	export default {
		props: {
			booker: Object,
			icon: String
		},

		computed: {
			letter() {
				return this.booker ? this.booker.name.slice(0, 1) : ' ';
			},
			className() {
				return this.booker ? 'avatar-' + (getBookerOrder(this.booker) % 38 + 1) : null;
			}
		}
	}
</script>

<style lang="scss">
	.avatar {
		$size: 2em;
		width: $size;
		height: $size;
		line-height: $size;
		text-transform: uppercase;
		display: inline-block;
		text-align: center;
		font-size: 125%;
		color: rgba(255,255,255,0.5);
		border-radius: 50%;

	}

	$white: rgba(255, 255, 255, 0.5);
	$black: rgba(0, 0, 0, 0.5);
	$colors: (#EF5350, $white),
			(#5C6BC0, $white),
			(#26A69A, $black),
			(#FFEE58, $black),
			(#8D6E63, $white),
			(#EC407A, $white),
			(#42A5F5, $black),
			(#66BB6A, $black),
			(#FFCA28, $black),
			(#BDBDBD, $black),
			(#AB47BC, $white),
			(#29B6F6, $black),
			(#9CCC65, $black),
			(#FFA726, $black),
			(#78909C, $white),
			(#7E57C2, $white),
			(#26C6DA, $white),
			(#D4E157, $white),
			(#FF7043, $black),
			(#E57373, $black),
			(#7986CB, $white),
			(#4DB6AC, $black),
			(#FFF176, $black),
			(#A1887F, $white),
			(#F06292, $black),
			(#64B5F6, $black),
			(#81C784, $black),
			(#FFD54F, $black),
			(#E0E0E0, $black),
			(#BA68C8, $white),
			(#4FC3F7, $black),
			(#AED581, $black),
			(#FFB74D, $black),
			(#90A4AE, $black),
			(#9575CD, $white),
			(#4DD0E1, $black),
			(#DCE775, $black),
			(#FF8A65, $black);
	@for $i from 1 through length($colors) {
		&.avatar-#{$i} {
			$color: nth($colors, $i);
			background-color: nth($color, 1);
			color: nth($color, 2);
		}
	}
</style>


// WEBPACK FOOTER //
// src/ui/widgets/avatar.vue